import {fetchJSON} from "../../helpers/Helpers";
import AuthService from "../AuthService";

export default class AuthApi {

    static callId = 0;

    static login(username, password, ip = null, callback) {

        AuthApi.callId++;
        const callId = AuthApi.callId;

        let formData = new FormData();
        formData.append('username', username);
        formData.append('password', password);
        formData.append('ip', ip);
        fetchJSON('/api/auth/login', {
            method: 'post',
            body: formData,
        })
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static logout(callback) {

        AuthApi.callId++;
        const callId = AuthApi.callId;

        const options = {
            headers: new Headers({
                'Authorization': 'Bearer ' + AuthService.getToken(),
                'pragma': 'no-cache',
                'cache-control': 'no-cache'
            })
        };
        fetchJSON('/api/auth/logout', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static getRecentActivity(allowCache, callback) {

        AuthApi.callId++;
        const callId = AuthApi.callId;

        const options = {
            headers: new Headers({
                'Authorization': 'Bearer ' + AuthService.getToken()
            })
        };
        if (allowCache) {
            options.headers.append('cache-control', 'max-age=300');
        }
        else {
            options.headers.append('pragma', 'no-cache');
            options.headers.append('cache-control', 'no-cache');
        }
        fetchJSON('/api/auth/recent-activity', options)
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });
        return callId;
    }

    static getSecStage(callback){
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        const url = '/api/globals/secstage';
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
            });
    }
}
